module.exports = __webpack_public_path__ + "img/YouTrack_icon.5a4fbd11.png";